import { useTranslation } from '@/hooks/useTranslation';
import { useReveal } from '@/hooks/useReveal';
import { Linkedin, Github, Mail } from 'lucide-react';
import ceoImg from '@/assets/team-ceo.jpg';
import ctoImg from '@/assets/team-cto.jpg';
import uxImg from '@/assets/team-ux.jpg';
import mlImg from '@/assets/team-ml.jpg';

const teamImages = [ceoImg, ctoImg, uxImg, mlImg];

const TeamSection = () => {
  const { t } = useTranslation();
  useReveal();

  return (
    <section id="team">
      <div className="team-header rev">
        <div>
          <div className="section-tag">{t.team.tag}</div>
          <h2 className="section-h" style={{ whiteSpace: 'pre-line' }}>{t.team.title}</h2>
        </div>
        <p className="section-sub">{t.team.subtitle}</p>
      </div>

      <div className="team-grid">
        {t.team.members.map((member, i) => (
          <div className={`team-card rev del-${i + 1}`} key={i}>
            <div className="team-img">
              <img src={teamImages[i]} alt={member.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              <div className="team-img-overlay">
                <div className="team-social">
                  <a href="#"><Linkedin size={14} /></a>
                  <a href="#"><Github size={14} /></a>
                  <a href="#"><Mail size={14} /></a>
                </div>
              </div>
            </div>
            <div className="team-info">
              <div className="team-role">{member.role}</div>
              <h3>{member.name}</h3>
              <p>{member.bio}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TeamSection;
